import errorManager from '@/rollbar.js';

const setFields = function (urlForDecodeDiagnosiInfermieristica) {
  $('#guest_needs').on('select2:select', function (e) {
    $.ajax({
      url: urlForDecodeDiagnosiInfermieristica,
      data: {
        desc: e.params.data.id,
      },
      cache: false,
      type: 'GET',
      success: function (response) {
        let selectedValue = response[0]?.type_id;

        // Ricreo select2 passando i nuovi dati
        $('#select-area')
          .select2({
            theme: 'bootstrap',
          })
          .val(selectedValue)
          .trigger('change');
      },
      error: function (xhr) {
        console.log('Errore nel caricamento delle aree');
      },
    });
  });
};

const init = (urlForDecodeDiagnosiInfermieristica) => {
  try {
    setFields(urlForDecodeDiagnosiInfermieristica);
  } catch (e) {
    errorManager(e);
  }
};

window.AreaSelectForGuestNeeds = {
  init: init,
};
